/* ==========================================================================
   UG PRODUCT PAGE - the model chip on the gallery.

   Collapsed it is just the icon, so it never sits in front of the photo more
   than it has to. One tap opens the line about the model, another closes it.
   The open state lives in aria-expanded, so the stylesheet does the rest and
   a screen reader is told the same thing.
   ========================================================================== */

(function () {
  function bind(chip) {
    if (chip.dataset.ugpBound) return;
    chip.dataset.ugpBound = '1';

    chip.addEventListener('click', function (event) {
      /* The chip floats on top of the carousel, which would otherwise take the tap as a slide change. */
      event.preventDefault();
      event.stopPropagation();

      var open = chip.getAttribute('aria-expanded') === 'true';
      chip.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.ugp-model-chip'), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Picking a colour reloads the page, but a variant with its own image set only re-renders the gallery. */
  document.addEventListener('variant:change', function () {
    setTimeout(init, 100);
  });

  if (window.MutationObserver) {
    var pending = null;

    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        init();
      }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
